const baseIntro = [
  {
    target: '#tour-step-1',
    content: 'Navigate through your profile using the menu on the left side of the screen.',
    disableBeacon: true,
    placement: 'right-end',
    spotlightPadding: 0,
  },
  {
    target: '#tour-step-2',
    content: 'Click on the horizontal tabs to fill out the required information.',
    spotlightPadding: 12,
    placement: 'bottom',
    floaterProps: { offset: 8 },
  },
  {
    target: '#tour-step-profile-preview',
    content:
      'Profile preview shows how companies see you in the seafarers list. You can always check here how your profile looks.',
    disableScrolling: true,
    spotlightPadding: 10,
    placement: 'bottom',
    floaterProps: { offset: 8 },
    styles: {
      spotlight: {
        borderRadius: 9,
      },
    },
  },
  {
    target: '#tour-step-3',
    content:
      'Hover over the icon to see the recommendations for filling out your data. This information is individually tailored to each section of your profile.',
    placement: 'left',
    spotlightPadding: 4,
    styles: {
      spotlight: {
        borderRadius: 9,
      },
    },
  },
  {
    target: '#tour-step-4',
    content:
      'Hover over the Profile completion status to see the level of your profile completeness and the links to the sections to be filled.',
    spotlightPadding: 12,
    styles: {
      spotlight: {
        borderRadius: 9,
      },
    },
  },
  {
    target: '#tour-step-store',
    content:
      'Open the Store to discover paid subscriptions that can improve your job search experience on the platform.',
    spotlightPadding: 8,
    placement: 'top',
    // floaterProps: { offset: 8 },
    styles: {
      spotlight: {
        borderRadius: 11,
      },
    },
  },
  {
    target: '#tour-step-services',
    content:
      'This panel shows your active services and notifications. Here you can quickly manage premium features and see important updates.',
    spotlightPadding: 8,
    styles: {
      spotlight: {
        borderRadius: 11,
      },
    },
  },
  {
    target: '#tour-step-5',
    content: 'The Support chat helps to resolve any technical issues.',
    spotlightPadding: 5,
    styles: {
      spotlight: {
        borderRadius: 11,
      },
    },
  },
  {
    target: '#tour-step-6',
    content: 'Click here to exit your profile or see the page with vacancies.',
    spotlightPadding: 10,
    placement: 'bottom',
    floaterProps: { offset: 8 },
    styles: {
      spotlight: {
        borderRadius: '11',
        // marginLeft: 1,
      },
    },
  },
]

export const getIntroSteps = ({ isMobile, grandTotal }) => {
  const mobile = typeof isMobile === 'function' ? isMobile() : Boolean(isMobile)
  const total = typeof grandTotal === 'number' ? grandTotal : null

  const servicesTarget = mobile ? '#tour-step-services-mobile' : '#tour-step-services-desktop'

  const withDeviceTargets = baseIntro.map((s) => {
    if (s.target === '#tour-step-services') return { ...s, target: servicesTarget }
    if (mobile && s.target === '#tour-step-1') {
      return {
        ...s,
        content: 'Use this menu to navigate between profile sections. Tap any item to open the needed page.',
        placement: 'right',
        spotlightPadding: 8,
      }
    }
    if (mobile && s.target === '#tour-step-2')
      return { ...s, placement: 'bottom-start', spotlightPadding: 10, floaterProps: { offset: 12 } }
    if (mobile && s.target === '#tour-step-profile-preview')
      return { ...s, placement: 'bottom', spotlightPadding: 10, floaterProps: { offset: 12 } }
    if (mobile && s.target === '#tour-step-6')
      return { ...s, placement: 'top', spotlightPadding: 12, floaterProps: { offset: 12 } }
    return s
  })

  const withoutCompletion =
    total !== null && total >= 100 ? withDeviceTargets.filter((s) => s.target !== '#tour-step-4') : withDeviceTargets

  if (!mobile) return withoutCompletion

  return [
    {
      target: '#tour-step-0-mobile',
      content: 'Open the menu to navigate through your profile.',
      disableBeacon: true,
      placement: 'bottom',
      spotlightPadding: 5,
      styles: {
        spotlight: {
          borderRadius: 11,
        },
      },
    },
    {
      target: '#tour-step-1',
      content: 'Navigate through your profile using the menu on the left side of the screen.',
      disableBeacon: true,
      placement: 'bottom',
      spotlightPadding: 0,
      styles: {
        spotlight: {
          borderRadius: 11,
        },
      },
    },
    ...withoutCompletion.slice(1),
  ]
}

export const handleProfileAsideJoyride = (event, { isMobile, stepsLength }) => {
  const mobile = typeof isMobile === 'function' ? isMobile() : Boolean(isMobile)
  if (!mobile) return

  if (event.type === 'step:before') {
    if (typeof document !== 'undefined') {
      document.documentElement.scrollLeft = 0
      document.body.scrollLeft = 0
    }
    if (typeof window !== 'undefined') {
      window.scrollTo({ left: 0, top: window.scrollY })
    }
  }

  if (event.type === 'step:before' && event.step?.target === '#tour-step-profile-preview') {
    const el = document.querySelector('#tour-step-profile-preview')
    if (el) {
      let parent = el.parentElement
      while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent)
        const canScrollX =
          (style.overflowX === 'auto' || style.overflowX === 'scroll') && parent.scrollWidth > parent.clientWidth

        if (canScrollX) {
          const parentRect = parent.getBoundingClientRect()
          const elRect = el.getBoundingClientRect()
          const targetLeft =
            parent.scrollLeft + (elRect.left - parentRect.left) - (parentRect.width / 2 - elRect.width / 2)

          parent.scrollTo({ left: targetLeft, behavior: 'smooth' })

          window.setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
          }, 350)
          break
        }

        parent = parent.parentElement
      }
    }
  }

  if (event.type === 'step:before' && event.index === 1) {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:open'))
  }

  if (event.type === 'step:before' && event.step?.target === '#tour-step-4') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:open'))
  }

  if (event.type === 'step:before' && event.step?.target === '#tour-step-6') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:open'))
  }

  if (event.type === 'step:before' && event.step?.target === '#tour-step-services-mobile') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:open'))
  }

  if (event.type === 'step:after' && event.index === 1) {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:close'))
  }
  if (event.type === 'step:after' && event.step?.target === '#tour-step-4') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:close'))
  }

  if (event.type === 'step:after' && event.step?.target === '#tour-step-6') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:close'))
  }
  if (event.type === 'step:after' && event.step?.target === '#tour-step-services-mobile') {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:close'))
  }

  if (event.type === 'step:after' && typeof stepsLength === 'number' && event.index === stepsLength - 1) {
    window.dispatchEvent(new CustomEvent('nextship:profile-aside:close'))
  }
}

export const introStyles = {
  options: {
    overlayColor: 'rgba(0, 0, 0, 0.5)',
    arrowColor: 'transparent',
    zIndex: 1300,
  },
  spotlightPadding: 0,

  beacon: {
    outline: 'none',
  },
}
